<template>
    <div class="main">
        <div class="video">
      <video :height="getWindowHeight()" :width="getWindowWidth()" autoplay muted>
        <source src="../assets/tacet-logo-with-transition.mp4">
      </video>
        </div>
    </div>
</template>

<script>
export default {
    name: "Video",
    props: {
        videoSource: String
    },
    methods: {
        getWindowHeight() {
            return window.innerHeight;
        },
        getWindowWidth() {
            return window.innerWidth;
        },
    }
}
</script>

<style>
.main{
    margin-top: 0px;
}
.video{
    margin-top: 0px;
}
</style>